const createScore = (min: number, max: number, label: string, roundMin: boolean = true, roundMax: boolean = true) => ({
    min,
    max,
    label,
    roundMin,
    roundMax
})

const scores = [
    createScore(0, 1.5, "Very slow", true, false),
    createScore(1.6, 10, "Slow", false, true),
    createScore(11, 100, "Moderate"),
    createScore(101, 500, "Rapid"),
    createScore(501, null, "Very Rapid")
];

export function getInfiltrationScore(rate: number): string {

    if (!rate) {
        return "No score";
    }

    var score = scores.filter(s => {
        var minRate = s.roundMin ? Math.round(rate) : rate;
        var maxRate = s.roundMax ? Math.round(rate) : rate;

        return s.min <= minRate && ((s.max && s.max >= maxRate) || (!s.max));
    });

    return score.length === 1 ? score[0].label : "Unknown score";

}

